module.exports = __webpack_public_path__ + "img/BLH_Android.a7052a21.png";